import React from 'react'
import styled from 'styled-components'



const Checkbox = ({ children, checked, handleClick }) => {

  return (
    <Wrap onClick={handleClick} >

      <InputWrap><input type="checkbox" checked={checked} onChange={handleClick} onClick={(e) => e.stopPropagation()} /></InputWrap>

      {children}
    </Wrap>
  )
}

export default Checkbox

const InputWrap = styled.div`
  width: 24px;
  aspect-ratio: 1; 
`

const Wrap = styled.div`
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 18px;

     
      & input {
        accent-color: var(--accent-btn-bg);
        scale: 1.7;
      }
    `